export const type = 'no-show';
